import { CommonModule} from '@angular/common';
import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';
import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconLocationPinFilled, homefieldIconArrowUpRightBoxed } from '@dsg-tech/homefield-angular-icons';
import { HomefieldTextLinkComponent } from './text-link.component';

@NgModule({
	imports: [
		CommonModule,
		HomefieldIconLibraryModule
	],
	declarations: [HomefieldTextLinkComponent],
	exports: [HomefieldTextLinkComponent]
})
export class HomefieldTextLinkModule {
	//eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
	constructor(private resolver: ComponentFactoryResolver, HomefieldIconsLibraryService: HomefieldIconsLibraryService) {
		HomefieldIconsLibraryService.registerIcons([homefieldIconLocationPinFilled, homefieldIconArrowUpRightBoxed]);
	}

	public resolveComponentFactory(): ComponentFactory<HomefieldTextLinkComponent> {
		return this.resolver.resolveComponentFactory(HomefieldTextLinkComponent);
	}
}
